<template>
  <section class="endorsement-info">
    <h2>Premium</h2>
    <premium-form-adjust
      ref="premium-form-endorsement"
      :classId="classId"
      :productId="productId"
      :form="form"
      :oldForm="oldForm"
      :prePremium="prePremium"
      :newPremium="newPremium"
      :diffPayable="diffPayable"
      :premiumData="premiumData"
      :info="info"
      :orderId="orderId"
      :mockRefer="mockRefer"
      :has-remark="true"
      :remarkList="remarkList"
      :formDataLock="formDataLock"
      @input-handling="handlerPremiumInputHanding"
      @get-quote="handlerPremiumGetQuoteMain"
      @get-form="handlerGetPremiumForm"
      @updateCancelPremium="handleCancelUpdatePremium"
      @update-form="handlerUpdatePremiumForm" />

    <section class="box-container">
      <h2>Excess</h2>
      <!-- 這裏也要區分產品 -->
      <product-excess-form
        ref="excess-form"
        :formDataLock="formDataLock"
        :form="form"/>
      <!--      <excess-info-->
      <!--          v-else-->
      <!--          ref="excess-info"-->
      <!--          :formData="formData"/>-->
    </section>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import OMath from '@/utils/math'
import PremiumFormAdjust from '@/views/components/premium-form-adjust'
import ExcessInfo from '@/views/tickets/components/info/excess-info'
import ProductExcessForm from '@/views/tickets/components/form/product-excess-form'

export default {
  name: 'adjustPremium',
  components: {
    ProductExcessForm,
    // ExcessInfo,
    PremiumFormAdjust,
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    isRefer: {
      type: Boolean,
      default: false
    },
    remarkList: {
      type: Array,
      default: () => ([])
    },
    isNext: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Boolean,
      default: false
    },
    mock: {
      type: Boolean,
      default: false
    },
    premiumData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // excessCheckbox: [
      //   {
      //     status: false,
      //     vlKey: 'general_ex_vl',
      //     typKey: 'general_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'china_general_ex_vl',
      //     typKey: 'china_general_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'theft_loss_ex_vl',
      //     typKey: 'theft_loss_ex_typ'
      //   },
      //   {
      //     status: false,
      //     vlKey: 'china_theft_loss_ex',
      //     typKey: 'china_theft_loss_typ'
      //   },
      // ],
      formData: {
        // excessCheckbox: [
        //   {},
        //   {},
        //   {},
        //   {}
        // ]
      },
      remainPremium: [],
      prePremium: {},
      newPremium: {
        base_prm: '',
        basic_prm: '',
        srd_amt: '',
        loading_amt: '',
        ncd_vl: '',
        code_disc_prm: '',
        mib_vl: '',
        mib_pct: '',
        ia_levy_pct: '',
        ia_levy_vl: '',
        spec_disc_prm: '',
        remaining_day: '',
        remaining_premium: '',
        // 裝修工程
        ec_levy_pct: '',
        ec_levy_vl: ''
      },
      diffPayable: {
        payable: ''
      },
      premiumForm: {
        handling_fee: 0,
        spec_disc_pct: '',
        code_disc_pct: '',
        cfd_pct: '',
        loading_pct: '',
        srd_pct: '',
        base_prm: '',
        basic_prm: '',
        spec_disc_prm: '',
        // 裝修工程
        ec_levy_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: ''
        // excess
        // tppd_ex: '',
        // tppd_young_driver_ex: '',
        // tppd_inexp_driver_ex: '',
        // tppd_unnamed_driver_ex: '',
        // remark: ''
      },
      // 用於判斷手填 premium 數據是否有變化（避免失去焦點時多次觸發）
      oldPremiumForm: {
        handling_fee: '',
        spec_disc_pct: '',
        code_disc_pct: '',
        cfd_pct: '',
        loading_pct: '',
        srd_pct: '',
        base_prm: '',
        basic_prm: '',
        spec_disc_prm: '',
        // 裝修工程
        ec_levy_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: ''
      },
      otherForm: {
        change_remark: '',
        endorse_remark: ''
      },
      premiumLock: false,
      tempPremium: {},
      formDataLock: 0,
      // 新增 premium 組件裡的
      premiumFormData: {}, //
      premiumParams: {},
      updatePremiumForm: {}

    }
  },
  computed: {
    oldExtraContent(){
      let {extra_benefits_content={}} = this.oldForm||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    nowExtraContent(){
      let {extra_benefits_content={}} = this.form||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    classId() {
      return this.form.class_id || 0
    },
    showEffectDate() {
      if (this.isRefer && !this.mock) {
        return false
      }
      return true
    },
    mockRefer() {
      if (this.isRefer && this.mock) {
        return true
      }
      return false
    },
    productId() {
      return this.form.product_id || 11
    },
    showECLevy() {
      const { ec_levy_pct } = this.formData
      return this.productId == 15 && ec_levy_pct > 0
    },
    hasExcess(){
      return [13,14,16,18].includes(this.productId)
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        const params = Object.assign(this.formData, val)
        this.formDataLock += 1
        this.formData = JSON.parse(JSON.stringify(params))
        // refer 才會用到
        // if (this.isRefer) {
        Object.keys(this.premiumForm).some(key => {
          // if(key == 'handling_fee') {
          //   this.premiumForm[key] = 0
          // }
          // else {
          if (key in this.formData) {
            this.premiumForm[key] = this.formData[key]
          }
          if (key == 'cfd_pct') {
            this.premiumForm['cfd_pct'] = val['ncd_pct']
          }
          if (key == 'cfd_amt') {
            this.premiumForm['cfd_amt'] = val['ncd_vl']
          }
          // }
        })
        // }
        // this.handlerGetQuoteMain()
        if(!this.isBeginEndorsement) {
          Object.keys(this.otherForm).some(key => {
            if(key in this.formData) {
              this.otherForm[key] = this.formData[key]
            }
          })
        }



      }
    },
    premiumData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.diff_payable && JSON.stringify(val.diff_payable) != '{}') {
          let data = JSON.parse(JSON.stringify(val))
          const {diff_payable = {}, new_premium = {}, old_premium = {}, remain_premium = []} = data
          this.prePremium = old_premium
          this.diffPayable = diff_payable
          this.remainPremium = remain_premium

          if(this.isCancel){
            const { handling_fee = 0 } = diff_payable
            this.premiumForm.handling_fee = handling_fee
          }else{
            const { handling_fee = 0 } = new_premium
            this.premiumForm.handling_fee = handling_fee
          }

          if (!this.isCancel) {
            let temp = this.handler().initNewPremium(this.newPremium)
            this.newPremium = Object.assign(temp, new_premium)
          }
          // 初始化数据，可能会因为手续费问题产生差异，所以这里重新计算一下
          this.inputHandlingFee(this.premiumForm.handling_fee)
        }
      }
    },
    info:{
      immediate: true,
      handler(val){
        if(val){
          let temp = this.handler().initNewPremium(this.newPremium)
          this.newPremium = Object.assign(temp, this.form)
          let extraBenefitPremium = {
            new_premium: this.form.extra_benefits_content,
            old_premium: this.oldForm.extra_benefits_content
          }
          this.premiumData.extra_benefits_premium = extraBenefitPremium
        }
      }
    },
    'diffPayable.payable': {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('get-payable', OMath.round(val))
      }
    },
    // 'premiumForm.handling_fee': {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     this.$emit('get-handlingfee', OMath.round(val))
    //   }
    // },
    // premium 組件新增
    'updatePremiumForm.handling_fee': {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('get-handlingfee', OMath.round(val))
      }
    },
  },
  methods: {
    submitForm(type) {
      // 反饋 premium 數據
      let params = {
        loading_pct: '',
        base_prm: '',
        cfd_pct: this.formData.ncd_pct,
        srd_pct: '',
        code_disc_pct: '',
        spec_disc_pct: '',
        spec_disc_prm: '',
        handling_fee: this.premiumForm.handling_fee,
        basic_prm:'',
        // tppd_ex: '',
        // tppd_young_driver_ex: '',
        // tppd_inexp_driver_ex: '',
        // tppd_unnamed_driver_ex: '',
        // remark: ''
      }
      Object.keys(params).some(key => {
        if (key in this.formData) {
          if (params[key] === '') {
            params[key] = this.formData[key]
          }
        }
      })

      // params = {
      //   ...params,
      //   ...this.otherForm
      // }

      this.premiumParams = params //  臨時存儲
      this.$refs['premium-form-endorsement'].submitForm(type)
      return

    },
    handlerGetQuoteMain() {
      const checked = this.handler().checkParams()
      if (checked) {
        this.$emit('get-quote', this.premiumForm)
      }
    },
    handlerPremiumGetQuoteMain(form) {
      this.$emit('get-quote', form)
    },
    handlerGetPremiumForm(form, type) {
      this.premiumFormData = form
      let params = Object.assign(this.premiumParams, form)
      const excessParams = this.$refs['excess-form'].submitForm()
      params = Object.assign(params, excessParams)
      params.plan_id = this.formData.quote_coverage_list.plan_info.plan_id || ''
      this.$emit('getFormData', params, type, this.otherForm)
    },
    handlerUpdatePremiumForm(form) {
      this.updatePremiumForm = form
    },
    handleCancelUpdatePremium(val){
      this.$emit('updateCancelPremium', val)
    },
    handlerPremiumInputHanding(value) {
      this.inputHandlingFee(value)
    },
    inputHandlingFee(val) {
      const value = Number(OMath.round(val))
      const prePayable = Number(OMath.round(this.prePremium.remaining_premium))
      const diffPayable = Number(Math.abs(this.diffPayable.payable))
      let result
      if (this.isCancel) {
        // 因爲顯示的是正數，所以
        result = OMath.round(diffPayable)
        // result = OMath.round(diffPayable - value)
        this.$set(this.diffPayable, 'payable', result)
      } else {
        const newPayable = Number(OMath.round(this.newPremium.remaining_premium))
        result = OMath.round(newPayable + value - prePayable)
        // this.diffPayable.payable = result
        result = this.diffPayable.payable
        this.$set(this.diffPayable, 'payable', result)
      }

    },
    handler() {
      return {
        checkParams: () => {
          let flag = false // 標記是否有空
          let different = false

          // let premiumForm = JSON.parse(JSON.stringify(this.premiumForm))
          // if(this.productId != 11) {
          //   delete premiumForm.base_prm
          //   delete premiumForm.srd_pct
          //   delete premiumForm.loading_pct
          //   delete premiumForm.cfd_pct
          // }
          // else {
          //   delete premiumForm.basic_prm
          // }

          const {
            base_prm,
            basic_prm,
            srd_pct,
            loading_pct,
            cfd_pct,
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
            ec_levy_prm,
            mat_dam_prm,
            tppd_limit_prm
          } = this.premiumForm

          let premiumForm = {
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
          }
          if(this.productId == 11) {
            premiumForm = {
              ...premiumForm,
              base_prm,
              srd_pct,
              loading_pct,
              cfd_pct
            }
          }
          else {
            premiumForm = {
              ...premiumForm,
              basic_prm
            }
          }

          if(this.productId == 15) {
            premiumForm = {
              ...premiumForm,
              ec_levy_prm,
              mat_dam_prm,
              tppd_limit_prm
            }
          }


          Object.keys(premiumForm).some(key => {
            const value = this.premiumForm[key]
            if (String(value).trim() === '') {
              flag = true
              return true
            }
            const oldValue = this.oldPremiumForm[key]
            if (value !== oldValue) {
              different = true
            }
          })
          if (flag || !different) {
            return false
          }
          this.oldPremiumForm = JSON.parse(JSON.stringify(this.premiumForm))

          return true
        },
        initNewPremium: (data) => {
          let result = {}
          Object.keys(data).some(key => {
            result[key] = this.formData[key]
          })
          return result
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.endorsement-info {
  // padding-top: 15px;
  .premium-container {
    display: flex;

    & > .box {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

    .box {
      flex: 1;
    }
  }

  .eff-box {
    width: 350px;
  }

  .box {
    .flex-excess {
      display: flex;
      align-items: center;

      & > .el-checkbox {
        margin: 0 15px;
      }

      & > span {
        display: inline-block;
        padding: 0 15px;
      }
    }

    .form-excess-half {
      width: 500px;
    }
  }

  .car-detail {
    display: flex;
    justify-content: space-between;

    .table {
      width: calc(50% - 10px);
    }
  }

  .box-container {
    width: 800px;
  }

  .refer-text {
    padding-top: 5px;
    font-size: 16px;
    color: #91939A;
  }

}
.extra-content-cancel{
  display: flex;
  flex-direction: column;
  .tr-extra{
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #e1e4e8;
    .extra-title{
      color: #24292e;
      font-weight: 500;
    }
    &:last-child {
      border-bottom: 0;
    }
    .tr {
      //flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      font-size: 14px;
      color: #24292e;
      line-height: 17px;
      border-bottom: 1px solid #e1e4e8;
      & > span {
        flex: 1;
      }
      &:last-child{
        border-bottom: 0;
      }
    }
  }
}
</style>
